export default {
  discount_price: "{discount}% introductory price discount",
  total: 'Total',
  per: 'per {period}',
  saved: "You just saved {amount} USD ({discount}% off)",
  pay_btn_card: 'Continue'
}
